import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import UCSColors from "@ucs/Utils/UCSColors";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    bgColorLeft = "bgColorLeft",
    bgColorRight = "bgColorRight",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.bgColorLeft]: string;
        [fields.bgColorRight]: string;
    };
}

type Props = OwnProps;

export interface BrandSectionalContentStyles {
    wrapper?: InjectableCss;
    content?: InjectableCss;
}

export const brandSectionalContentStyles: BrandSectionalContentStyles = {
    wrapper: {
        css: css`
            width: 100%;
            height: fit-content;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        grid-template-columns: 100%;
                    `,
                    css`
                        grid-template-columns: 100%;
                    `,
                    css`
                        grid-template-columns: 100%;
                    `,
                ]);
            }}
        `,
    },
    content: {
        css: css`
            width: 100%;
            min-height: 700px;
            padding: 67px 130px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            gap: 24px;
            & > * {
                min-width: 460px;
                max-width: 660px;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            max-width: 100%;
                            min-width: 300px;
                        `,
                        css`
                            max-width: 100%;
                        `,
                        css``,
                        css`
                            min-width: 400px;
                        `,
                    ]);
                }}
            }

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        min-height: 350px;
                        padding: 20px 20px 48px;
                        order: 2;
                    `,
                    css`
                        min-height: 480px;
                        padding: 40px 40px 50px;
                        order: 2;
                    `,
                    css`
                        min-height: 480px;
                        padding: 50px 60px 60px;
                        order: 2;
                    `,
                    css`
                        min-height: 450px;
                        padding: 60px 30px;
                    `,
                ]);
            }}
            @media only screen and (min-width: 1140px) and (max-width: 1280px) {
                padding: 66px 35px;
            }
            @media only screen and (min-width: 1140px) and (max-width: 1280px) {
                padding: 80px 55px;
            }
            @media only screen and (min-width: 1280px) and (max-width: 1444px) {
                padding: 90px 90px;
            }
        `,
    },
};

const styles = brandSectionalContentStyles;

const BrandSectionalContent: React.FC<Props> = ({ id, fields }) => {
    const { bgColorLeft, bgColorRight } = fields;

    const leftContentStyles = css`
        ${styles?.content?.css}
        background-color: ${bgColorLeft};
    `;
    const rightContentStyles = css`
        ${styles?.content?.css}
        background-color: ${bgColorRight};
    `;

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper css={leftContentStyles}>
                <Zone contentId={id} zoneName="Content1" />
            </StyledWrapper>
            <StyledWrapper css={rightContentStyles}>
                <Zone contentId={id} zoneName="Content2" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: BrandSectionalContent,
    definition: {
        group: "Brand Details",
        fieldDefinitions: [
            {
                name: fields.bgColorLeft,
                displayName: "Left Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: `${UCSColors.gray10}`,
                fieldType: "General",
            },
            {
                name: fields.bgColorRight,
                displayName: "Right Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: `${UCSColors.gray09}`,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
